import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, defer, map, of } from 'rxjs';
import { MailOrderProfileEnrollmentService } from 'src/app/services/mail-order-profile-enrollment/mail-order-profile-enrollment.service';
import { TokenService } from '../../services/token/token.service';
import { AuthService } from '../../services/auth/auth.service';

export const MailOrderAccessGuard: CanActivateFn = () => {
  // Inject services
  const authService = inject(AuthService);
  const mailOrderService = inject(MailOrderProfileEnrollmentService);
  const tokenService = inject(TokenService);
  const router = inject(Router);

  try {
    return defer(() => {
      if (authService.isAuthorizedByAzureB2c) {
        const clientId = tokenService.getClientIdFromToken();
        return mailOrderService
          .suppressMailOrderProfileByClientId(clientId)
          .pipe(
            map(
              (disable) => {
                if (disable) {
                  router.navigate(['/main']);
                }
                return disable ? false : true;
              },
              catchError(() => {
                return of(true);
              })
            )
          );
      } else {
        authService.logout();
        return of(false);
      }
    });
  } catch (error) {
    return of(true);
  }
};
